import { makeStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import Tippy from '@tippyjs/react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import 'tippy.js/dist/tippy.css';

const useStyles = makeStyles({
    container: {
        textAlign: 'left',
        padding: '10px'
    },
    header: {
        marginBottom: '15px',
        display: 'flex',
        alignItems: 'center'
    },
    headerText: {
        fontSize: 'large',
        marginLeft: '8px'
    },
    section: {
        marginBottom: '15px'
    },
    row: {
        marginBottom: '5px',
        display: 'flex',
        alignItems: 'center'
    },
    icon: {
        marginRight: '8px',
        fontSize: 'large'
    },
    greenIcon: {
        color: 'green'
    },
    redIcon: {
        color: 'red'
    }
});

const PasswordTooltip = ({ children }) => {
    const classes = useStyles();

    const tooltipContent = (
        <div className={classes.container}>
            <div className={classes.header}>
                <VpnKeyIcon className={classes.icon} />
                <span className={classes.headerText}>{i18next.t('password:tooltip.best-practices')}</span>
            </div>

            <div className={classes.section}>
                <div className={classes.row}>
                    <CheckCircleIcon className={`${classes.icon} ${classes.greenIcon}`} />
                    {i18next.t('password:tooltip.mix-words')}
                </div>
                <div className={classes.row}>
                    <CheckCircleIcon className={`${classes.icon} ${classes.greenIcon}`} />
                    {i18next.t('password:tooltip.use-modified-passphrase')}
                </div>
                <div className={classes.row}>
                    <CheckCircleIcon className={`${classes.icon} ${classes.greenIcon}`} />
                    {i18next.t('password:tooltip.vary-upper-lower')}
                </div>
                <div className={classes.row}>
                    <CheckCircleIcon className={`${classes.icon} ${classes.greenIcon}`} />
                    {i18next.t('password:tooltip.use-unrelated-words')}
                </div>
                <div className={classes.row}>
                    <CheckCircleIcon className={`${classes.icon} ${classes.greenIcon}`} />
                    {i18next.t('password:tooltip.store-passwords')}
                </div>
            </div>

            <div>
                <div className={classes.row}>
                    <CancelIcon className={`${classes.icon} ${classes.redIcon}`} />
                    {i18next.t('password:tooltip.no-personal-information')}
                </div>
                <div className={classes.row}>
                    <CancelIcon className={`${classes.icon} ${classes.redIcon}`} />
                    {i18next.t('password:tooltip.never-reuse-password')}
                </div>
            </div>
        </div>
    );

    return (
        <Tippy
            content={tooltipContent}
            placement="top"
            trigger="click"
            interactive={true}
            arrow={true}
            theme="light"
        >
            {children}
        </Tippy>
    );
};

PasswordTooltip.propTypes = {
    children: PropTypes.node.isRequired
};

export default PasswordTooltip;